import axios from 'axios';

export default (id, offset) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}discount-package-catalogs/${id}/move`, {
        offset: Number(offset),
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
